export enum BusinessLine {
    Private,
    Corporate,
    Retail,
}
